import React, { useEffect, useState } from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface LeaseLiabilityClassicRommsProps {
  onBack?: () => void;
}

interface LeaseRommItem {
  id: string;
  risk: string;
  assertion: string;
  options: string[];
  workspace: string;
}

export default function LeaseLiabilityClassicRomms({ onBack }: LeaseLiabilityClassicRommsProps) {
  const workspace = "Lease Liability";
  const [rommsOverride, setRommsOverride] = useState<LeaseRommItem[]>([]);

  useEffect(() => {
    const baseRomms: LeaseRommItem[] = [
      {
        id: "LEASE.SR.001",
        risk: "Lease liability does not exist and/or the entity does not have the rights or obligations.",
        assertion: "Existence, Rights & Obligations",
        options: ["Lower", "Higher", "Significant", "NRPMM"],
        workspace,
      },
      {
        id: "LEASE.SR.002",
        risk: "Lease liability is recorded at incorrect amount.",
        assertion: "Valuation",
        options: ["Lower", "Higher", "Significant", "NRPMM"],
        workspace,
      },
      {
        id: "LEASE.SR.003",
        risk: "Lease liability is incomplete.",
        assertion: "Completeness",
        options: ["Lower", "Higher", "Significant", "NRPMM"],
        workspace,
      },
      {
        id: "LEASE.SR.004",
        risk: "Lease liability is recorded in incorrect account.",
        assertion: "Classification",
        options: ["Lower", "Higher", "Significant", "NRPMM"],
        workspace,
      },
    ];
    setRommsOverride(baseRomms);
  }, []);

  return (
    <PayrollRomms
      onBack={onBack || (() => {})}
      onComplete={() => {}}
      workspace={workspace}
      rommsOverride={rommsOverride}
    />
  );
}
